// extracted by mini-css-extract-plugin
module.exports = {"root":"userSearch_root__15QrY","icon":"userSearch_icon__2Peyj","input":"userSearch_input__tALuK"};